import { useState } from 'react';
import { Modal } from '@round/whitelabel-ui';
import { DatePicker } from '@round/whitelabel-ui';
import { Button } from '@round/whitelabel-ui';
import moment from 'moment/moment';

type DraftExpectedByDatePickerProps = {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (date: string) => void;
    isSubmitting: boolean;
};

const DraftExpectedByDatePicker = ({ isOpen, onClose, onSubmit, isSubmitting }: DraftExpectedByDatePickerProps) => {
    const [date, setDate] = useState<Date | null>(null);
    const handleClose = () => {
        setDate(null);
        onClose();
    };

    return (
        <Modal hideCloseIcon closeOnEscape closeOnOverlayClick isOpen={isOpen} onClose={handleClose}>
            <Modal.Body>
                <DatePicker onChange={setDate} value={date} />
            </Modal.Body>

            <Modal.Actions>
                <Button
                    appearance="primary"
                    type="button"
                    isLoading={isSubmitting}
                    disabled={!date}
                    onClick={() => {
                        if (date) {
                            onSubmit(moment(date).format('YYYY-MM-DD[T]HH:mm:ss[Z]'));
                        }
                    }}
                >
                    Apply
                </Button>
                <Button appearance="ghost" onClick={handleClose}>
                    Cancel
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default DraftExpectedByDatePicker;
